import { Outlet, ScrollRestoration } from "react-router-dom";
import AppBar from "./AppBar";
import AuthProvider, { AuthIsNotSignedIn, AuthIsSignedIn } from "../contexts/AuthProvider";
import LoginPage from "./LoginPage";
import { Helmet } from "react-helmet";

export default function Root() {
    return (
        <AuthProvider>
            <Helmet>
                <title>Matplanering</title>
            </Helmet>
            <AuthIsSignedIn>
                <AppBar></AppBar>
                <Outlet />
            </AuthIsSignedIn>
            <AuthIsNotSignedIn>
                <LoginPage></LoginPage>
            </AuthIsNotSignedIn>
            <ScrollRestoration />
        </AuthProvider>
    );
}
